import { IRemindersHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useServiceReminders = (): IRemindersHook => {
  const { reminderStore } = useStore();
  const { serviceReminders, serviceRemindersLoading } = reminderStore;

  useEffect(() => {
    reminderStore.getAllServiceReminders({
      isService: true,
      maxResultCount: 50,
      skipCount: 0,
    });
  }, [reminderStore]);

  return {
    reminders: Array.from(serviceReminders.values()).sort(
      (a, b) => (a.serviceOrderPosition ?? 0) - (b.serviceOrderPosition ?? 0)
    ),
    loading: serviceRemindersLoading,
  };
};
